var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('x-default-data-table',{attrs:{"x-options":_vm.tableOptions},scopedSlots:_vm._u([{key:"item.image",fn:function(ref){
var item = ref.item;
return [(item.image)?_c('v-img',{attrs:{"src":item.image,"height":"50px","width":"50px","contain":""}}):_vm._e()]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }